//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: [
        {
          name: 'reportName',
          label: 'Отчёт',
          align: 'left',
          field: 'reportName',
          sortable: true
        },
        {
          name: 'value',
          label: 'Результат',
          align: 'left',
          field: 'value',
          sortable: true
        }
      ]
    }
  },
  computed: {
    thisReportNumberValue: {
      get: function () {
        return this.thisReportValue.value
      },
      set: function (value) {
        if (value === '') {
          value = null
        }
        this.thisReportValue.value = value
      }
    },
    thisReportValue: function () {
      return this.resultValue.value.find(val => val.reportId === this.report.id)
    },
    otherReportValues: function () {
      return this.resultValue.value.filter(val => val.reportId !== this.report.id)
    }
  }
}

